import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { messageBarStyle } from "./style";

import TooltipOffers from "../TooltipOffers/TooltipOffers";
import { useNewOffer } from "../../../js/context/new-offer";
import Loading from "../Loading/Loading";
import { isMobile } from "../../../../js/components/searchform/utils/common";

const MessageBar = ({bottomSize}) => {
	const [ruleToShowBar, setRuleToShowBar] = useState(false);
	const [reductions, setReductions] = useState(0);
	const [sales, setSales] = useState(0);

	const { currentProgram, offerData, pricesData, rankingData, smilesDiamond } = useNewOffer();

	useEffect(() => {
		const { quant, averageMiles, reductions } = offerData.data;
		const { minMiles, maxMiles } = pricesData.data;
		const { countAllowedSales } = rankingData.data;

		const calcAllowedSales = parseInt(quant / (averageMiles || 3500));
		const sales = calcAllowedSales > countAllowedSales ? countAllowedSales : calcAllowedSales;

		setRuleToShowBar(
			parseInt(quant) >= minMiles && parseInt(quant) <= maxMiles && !!countAllowedSales
		);
		setSales(sales);
		setReductions(reductions);
	}, [offerData, pricesData, rankingData, smilesDiamond]);

	return (
		ruleToShowBar && (
			<div
				className={css`
					${bottomSize ? messageBarStyle(bottomSize) : messageBarStyle()};
				`}
			>
				{rankingData.isFetching ? (
					<Loading width={18} height={18} />
				) : currentProgram.id === 4 && offerData.data.quant >= 35000 && reductions ? (
					!isMobile() ? (
						<>
							<p>
								Com esta oferta, é possível fazer até{" "}
								<span>
									{sales}&nbsp;venda{sales > 1 && "s"}
								</span>
								, sendo no máximo&nbsp;{reductions} delas com redução de milhas.
							</p>
							<TooltipOffers
								content={
									<p style={{ fontWeight: "bold", textAlign: "left" }}>
										Cliente Smiles da categoria Diamante pode resgatar até 10 passagens por ano com
										qualquer quantidade de milhas, utilizando até 35.000 milhas.
									</p>
								}
								position="top-end"
							/>
						</>
					) : (
						<>
							<div className="col-xs-13">
								<p>
									Podem ser feitas até{" "}
									<span>
										{sales}&nbsp;venda{sales > 1 && "s"}
									</span>
									, sendo no máximo&nbsp;{reductions} delas com redução de milhas.
								</p>
							</div>
							<div className="col-xs-3">
								<TooltipOffers
									content={
										<p style={{ fontWeight: "bold", textAlign: "left" }}>
											Cliente Smiles da categoria Diamante pode resgatar até 10 passagens por ano
											com qualquer quantidade de milhas, utilizando até 35.000 milhas.
										</p>
									}
									position="top-end"
								/>
							</div>
						</>
					)
				) : (
					<p>
						{isMobile() ? "Podem ser feitas até" : "Com esta oferta, é possível fazer até"}{" "}
						<span>
							{sales}&nbsp;venda{sales > 1 && "s"}
						</span>
						.
					</p>
				)}
			</div>
		)
	);
};

export default MessageBar;
